import { render, staticRenderFns } from "./ConfigWebsiteCohortsUpdate.vue?vue&type=template&id=333f07f8&scoped=true"
import script from "./ConfigWebsiteCohortsUpdate.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCohortsUpdate.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCohortsUpdate.vue?vue&type=style&index=0&id=333f07f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f07f8",
  null
  
)

export default component.exports